import type { Control, FieldValues, Path } from 'react-hook-form';
import LabelT from '../Label/LabelT';
import InputT from './InputT';

interface Options {
  [key: string]: any;
}

type InputWithLabelProps<T extends FieldValues> = {
  field?: Path<T>;
  placeholder: string;
  options?: Options;
  control?: Control<T>;
  label: string;
  labelSubText?: string;
  id?: string;
  type?: 'text' | 'email' | 'password' | 'color';
  inputClassName?: string;
  inputParentClassName?: string;
  labelClassName?: string;
  error?: string;
  errorClassName?: string;
};

export function InputWithLabelT<T extends FieldValues>({
  field,
  placeholder,
  options,
  control,
  label,
  labelSubText,
  id,
  type,
  inputClassName = '',
  inputParentClassName = '',
  labelClassName = '',
  error,
  errorClassName = '',
}: InputWithLabelProps<T>) {
  const { disabled, minLength, maxLength } = options || {};

  return (
    <>
      <LabelT
        text={label}
        subText={labelSubText}
        htmlFor={id}
        className={`${labelClassName} ${disabled ? 'pointer-events-none' : ''}`}
      />
      <div className='mt-1'>
        <InputT
          className={`p-0 w-[26px] ${inputClassName} ${error ? '!ring-red-base' : ''}`}
          parentClassName={inputParentClassName}
          type={type || 'text'}
          id={id}
          placeholder={placeholder}
          minLength={minLength || 0}
          maxLength={maxLength || Number.MAX_SAFE_INTEGER}
          field={field}
          control={control}
          options={options}
        />
        {error && (
          <p className={`${errorClassName} text-red-base text-pico mt-[-5px]`}>
            {error}
          </p>
        )}
      </div>
    </>
  );
}

export default InputWithLabelT;
